<template>
  <div id="componente">
    <v-dialog v-model="modelValue" persistent fullscreen>
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="fecharDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Compra para Múltiplas Filiais</v-toolbar-title>

          <ConverterEmbalagem class="ml-3" />

          <v-spacer />

          <CarrinhoDeCompra
            :buscarPedidos="atualizarCarrinho"
            class="text-truncate py-3 pr-3"
            style="width: 500px"
            @atualizarProdutosCompra="carrinhoDeCopraAlterado"
          />
        </v-toolbar>

        <v-card-text class="pa-0">
          <div class="display-flex align-center px-3">
            <div class="color-text d-flex mr-10">
              <p class="ma-0">{{ `FORNECEDOR: ${fornecedorCompra.id} - ${fornecedorCompra.razao_social}` }}</p>
              <p class="ml-10 my-0">{{ `PRAZO ${prazoFornecedor} DIAS` }}</p>
            </div>

            <template v-if="produtosSelecionados.length">
              <v-btn @click="removerProdutosSelecionados()" color="error" small>
                <v-icon left>mdi-delete</v-icon>remover
                <span class="qtde-top-button-small">{{produtosSelecionados.length}}</span>
              </v-btn>

              <v-btn
                color="#042333"
                @click="verificaMultiplosProdutoValidos(produtosSelecionados)"
                class="ml-10"
                small dark
              >
                <v-icon color="#FFF" left small>mdi-cart</v-icon> Adicionar
                <span class="qtde-top-button-small">{{produtosSelecionados.length}}</span>
              </v-btn>
            </template>

            <v-spacer></v-spacer>

            <v-text-field
              v-model="pesquisa"
              label="Pesquisa"
              hide-details
              height="28"
              clearable
              class="mt-0 mb-2"
              append-icon="mdi-magnify"
              style="max-width: 450px"
            ></v-text-field>
          </div>

          <v-divider></v-divider>

          <div>
            <v-data-table
              id="data-table-multifiliais-produtos"
              v-model="produtosSelecionados"
              :headers="headers"
              :search="pesquisa"
              fixed-header
              height="calc(100vh - 165px)"
              :items="listaDeProdutosDinamico"
              item-key="index"
              :items-per-page="-1"
              show-expand
              single-expand
              show-select
              @click:row="expandirProdutoPorFilial"
              :item-class="activeRowSelected"
              v-rolagem-data-table="(scroll) => scrollDataTableRealTime = scroll"
            >
              <template #header>
                <CabecalhoGruposItens />
              </template>

              <template #header.data-table-select v-if="analisandoPorFilial">
                <v-btn @click.stop color="#d3d3d3" icon>
                  <v-icon>mdi-checkbox-blank-outline</v-icon>
                </v-btn>
              </template>

              <template #header.data-table-expand>
                <div>
                  <v-icon v-if="analisandoPorFilial">mdi-minus</v-icon>
                  <v-icon v-else>mdi-plus</v-icon>
                </div>
              </template>

              <template #header.preco_atacado_varejo>
                <p class="ma-0" v-text="'Atacado'" />
                <p class="ma-0" v-text="'Varejo'" />
              </template>

              <template #item.preco_atacado_varejo="{item}">
                <p class="ma-0 font-11">
                  {{`A:&nbsp;${Helpers.truncarEFormatarValor(item.preco_atacado, 2)}`}}
                </p>
                <p class="ma-0 font-11">
                  {{`V:&nbsp;${Helpers.truncarEFormatarValor(item.preco_varejo, 2)}`}}
                </p>
              </template>

              <template v-if="analisandoPorFilial" #item.data-table-select="{item, select, isSelected}">
                <v-icon v-if="item.no_carrinho" right>mdi-check-bold</v-icon>
                <v-btn icon v-else-if="item.filial != 9999" @click="select(!isSelected)">
                  <v-icon v-if="isSelected">mdi-checkbox-marked</v-icon>
                  <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                </v-btn>

                <v-btn v-else icon @click.stop color="#d3d3d3">
                  <v-icon>mdi-checkbox-blank-outline</v-icon>
                </v-btn>
              </template>

              <template #item.data-table-expand="{item, isExpanded}">
                <v-btn icon v-show="item.filial == 9999" style="margin-left: -6px">
                  <v-icon v-if="isExpanded">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <template #item.filial="{item}">
                {{ item.filial == 9999 ? 'Todas' : item.filial  }}
              </template>

              <template #header.qtde_venda_ant2>{{ getNomeMes(indexMexAnterior(mesAtual - 3)) }}</template>
              <template #header.qtde_venda_ant1>{{ getNomeMes(indexMexAnterior(mesAtual - 2)) }}</template>
              <template #header.qtde_venda_ant0>{{ getNomeMes(mesAtual - 1) }}</template>

              <template #item.descricao_produto="{ item }">
                <div class="d-flex align-center">
                  <detalhes-produto-dialog :produto="item" class="ml-n3" />

                  {{ `${item.idproduto} - ${item.descricao_produto}` }}
                </div>
              </template>

              <template #item.unidade_compra="{item}">
                {{ embalagemMasterAtivada ? item.unidade_master : item.unidade_compra}}
              </template>

              <template #item.embalagem_master_desc="{item}">
                {{ embalagemMasterAtivada ? item.embalagem_master_desc : item.embalagem}}
              </template>

              <template #item.total_ult_entrada="{ item }">
                <template v-if="item.data_entrada">
                  R$ {{ Helpers.truncarEFormatarValor(item.preco_custo_base * item.multiplo_compra, 2) }}
                </template>
                <template v-else>-</template>
              </template>

              <template #item.data_entrada="{ item }">
                {{ item.data_entrada ? item.data_entrada : '-' }}
              </template>

              <template #item.qtde_entrada="{ item }">
                <template v-if="item.data_entrada">
                  {{formatarValor(converteEmbalagemValor(item, 'qtde_entrada'))}}
                </template>
                <template v-else>-</template>
              </template>

              <template #item.qtde_venda_ant2="{ item }">
                {{ Helpers.truncarEFormatarValor(converteEmbalagemValor(item, 'qtde_venda_ant2')) }}
              </template>

              <template #item.qtde_venda_ant1="{ item }">
                {{ Helpers.truncarEFormatarValor(converteEmbalagemValor(item, 'qtde_venda_ant1')) }}
              </template>

              <template #item.qtde_venda_ant0="{ item }">
                {{ Helpers.truncarEFormatarValor(converteEmbalagemValor(item, 'qtde_venda_ant0')) }}
              </template>

              <template #item.consumo_medio_mensal="{ item }">
                {{ Helpers.truncarEFormatarValor(converteEmbalagemValor(item, 'consumo_medio_mensal')) }}
              </template>

              <template #item.estoque="{ item }">
                {{ formatarValor(converteEmbalagemValor(item, 'estoque'), 2) }}
              </template>

              <template #item.estoque_transito="{ item }">
                {{ formatarValor(converteEmbalagemValor(item, 'estoque_transito'), 2) }}
              </template>

              <template #item.saida_icms="{ item }">
                {{ formatarValor(item.saida_icms) }}
              </template>

              <template #item.icms="{ item }">
                {{ formatarValor(item.icms) }}
              </template>

              <template #item.iva="{ item }">
                {{ formatarValor(item.iva) }}
              </template>

              <template #item.inter="{ item }">
                {{ formatarValor(item.inter) }}
              </template>

              <template #item.ext="{ item }">
                {{ formatarValor(item.ext) }}
              </template>

              <template #item.pis="{ item }">
                {{ formatarValor(item.pis) }}
              </template>

              <template #item.cofins="{ item }">
                {{ formatarValor(item.cofins) }}
              </template>

              <template #item.preco_custo="{ item }">
                <template v-if="item.filial != 9999">
                  <sys-input-formatador
                    v-model="item.preco_custo"
                    :remover-valor-irrelevante="true"
                    :max-digitos="QTDE_DECIMAIS"
                    centralizar
                    class="input-regular"
                    :erro-dado-informado="item.preco_custo <= 0"
                    :disabled="item.no_carrinho"
                    @focus="$event.target.select()"
                    @click.stop
                    style="width: 70px"
                  ></sys-input-formatador>
                </template>

                <template v-else>
                  <template v-if="embalagemMasterAtivada">
                    {{ Helpers.truncarEFormatarValor(item.preco_custo * item.multiplo_compra, 2) }}
                  </template>
                  <template v-else>
                    {{ Helpers.truncarEFormatarValor(item.preco_custo, 2) }}
                  </template>
                </template>
              </template>

              <template #item.sugestao="{ item }">
                <div v-if="item.filial != 9999" class="d-flex align-center justify-center">
                  <sys-input-formatador
                    v-model="item.sugestao"
                    :remover-valor-irrelevante="true"
                    :max-digitos="QTDE_DECIMAIS"
                    centralizar
                    class="input-regular"
                    :erro-dado-informado="item.sugestao <= 0"
                    @focus="$event.target.select()"
                    :disabled="item.filial == 9999 || item.no_carrinho"
                    @click.stop
                    style="width: 80px"
                  ></sys-input-formatador>

                  <ConsolidaSugestoesDialog
                    :item="item"
                    :qtd-por-consolidar="qtdeTotalDoProdutoPorFilial - qtdeTotalProdutoAdicionadoNoCarrinho"
                    @consolidar="zerarSugestaoDeFiliais();item.sugestao = $event;"
                  />
                </div>

                <template v-else>
                  <div class="d-flex align-center justify-center" style="width: 80px">
                    <template v-if="analisandoPorFilial && qtdeTotalDoProdutoPorFilial > 0">
                      {{formatarValor(qtdeTotalDoProdutoPorFilial)}}
                    </template>
                    <template v-else>
                      {{formatarValor(converteEmbalagemValor(item, 'sugestao'))}}
                    </template>
                  </div>
                </template>
              </template>

              <template #header.action="{header}">
                {{header.text}}

                <visibilidade-de-colunas />
              </template>

              <template #item.action="{ item }">
                <div v-if="item.no_carrinho" class="d-flex justify-center">
                  <edicao-carrinho-dialog
                    :produto="item"
                    @produto-removido-do-carrinho="item.no_carrinho = false;atualizarCarrinho++"
                  ></edicao-carrinho-dialog>
                </div>
                <div v-else class="display-flex">
                  <template v-if="verificaValoresInputValidos(item)">
                    <v-tooltip top>
                      <template #activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>mdi-alert</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="item.preco_custo <= 0 || !item.preco_custo">Preço deve ser maior que 0.</span>
                      <span v-else>Quantidade/Sugestao deve ser maior que 0.</span>
                    </v-tooltip>
                  </template>

                  <template v-else>
                    <template v-if="! verificaSeMultiploDeLoteMinimo(item) && item.filial != 9999">
                      <valida-lote-minimo
                        v-model.number="item.sugestao"
                        :lote-minimo="item.lote_minimo"
                        class="ml-n1"
                      ></valida-lote-minimo>
                    </template>

                    <template v-else>
                      <v-btn
                        icon
                        @click.stop="verificaProdutoParaAdicionarNoCarrinho(item)">
                        <v-icon>mdi-cart</v-icon>
                      </v-btn>
                    </template>
                  </template>

                  <v-btn
                    title="Remover da Lista" icon
                    :disabled="analisandoPorFilial && item.filial == 9999"
                    @click.stop="produtosSelecionados=[item];removerProdutosSelecionados()"
                  >
                    <v-icon v-if="analisandoPorFilial && item.filial == 9999">mdi-delete-off</v-icon>
                    <v-icon v-else>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>

              <template #footer.prepend>
                <footer-data-table class="ml-2" />
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <dialog-status v-model="dialogStatus.show" title="Atenção" :messages="dialogStatus.txt">
      <template #opcoes>
        <v-spacer></v-spacer>
        <v-btn text @click="dialogStatus.show = false">ok, fechar</v-btn>
      </template>
    </dialog-status>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SysInputFormatador from '../../utils/InputFormatadorDeValor'
import ValidaLoteMinimo from '../ValidaLoteMinimo'
import CompraAPI from '../../../api/compra'
import CarrinhoDeCompra from '../carrinho/Index'
import mixinCompra from '../MixinCompra'
import FooterDataTable from './FooterDataTable'
import mixinMultifiliais from './Mixin'
import DetalhesProdutoDialog from './DetalhesProdutoDialog'
import EdicaoCarrinhoDialog from './EdicaoCarrinhoDialog'
import DialogStatus from '../../utils/DialogConfirmacao'
import helpersAuxiliar from './HeadersDataTableProdutos'
import CabecalhoGruposItens from "./CabecalhoGruposItens";
import ConverterEmbalagem from "../Embalagem/ConverterEmbalagem";
import VisibilidadeDeColunas from './VisibilidadeDeColunas'
import ConsolidaSugestoesDialog from "./ConsolidaSugestoesBotao";

export default {
  name: "DialogProdutosMultifiliais",
  components: {
    ConsolidaSugestoesDialog,
    VisibilidadeDeColunas,
    ConverterEmbalagem,
    CabecalhoGruposItens,
    EdicaoCarrinhoDialog,
    DetalhesProdutoDialog,
    FooterDataTable,
    SysInputFormatador,
    ValidaLoteMinimo,
    CarrinhoDeCompra,
    DialogStatus
  },
  mixins: [mixinCompra, mixinMultifiliais],
  model: {prop: 'modelValue', event: 'update:modelValue'},
  props: {
    modelValue: {type: Boolean, required: true},
    produtos: {type: Array, required: false},
    addComSucesso: {type: Boolean, required: false},
    completarCompra: {type: Boolean, required: false}
  },
  data () {
    return {
      prazoFornecedor: '',
      mesAtual: null,
      atualizarCarrinho: 0,
      linhaExpandida: {},
      linhaExpandidaAntiga: {},
      listaDeProduto: [],
      produtoPorFilial: [],
      produtosSelecionados: [],
      historicoProdutosExpandidos: [],
      headers: helpersAuxiliar,
      pesquisa: '',
      scrollDataTableRealTime: {
        target: {scrollTop: 0}
      },
      ultimoScrollTop: null,
      timerScroll: null,
      dialogStatus: {
        show: false,
        txt: []
      }
    }
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      fornecedorCompra: "fornecedor/getFornecedor",
      configuracoes: "configuracoes/carrinho",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster"
    }),
    qtdeItens () {
      return this.listaDeProduto.length
    },
    QTDE_DECIMAIS () {
      if (!this.configuracoes || !this.configuracoes.CASAS_DECIMAIS_CARRINHO) {
        return 4
      }

      return this.configuracoes.CASAS_DECIMAIS_CARRINHO
    },
    analisandoPorFilial () {
      return this.linhaExpandida && ![undefined, null].includes(this.linhaExpandida.index)
    },
    listaDeProdutosDinamico () {
      if (this.analisandoPorFilial) {
        return [this.linhaExpandida.item].concat(this.produtoPorFilial)
      }

      return this.listaDeProduto
    },
    qtdeTotalDoProdutoPorFilial () {
      if (!this.analisandoPorFilial) {
        return 0
      }

      const SOMA_SUGESTAO = (valorAtual, item) => valorAtual + parseFloat(item.sugestao || 0)

      return this.produtoPorFilial.reduce(SOMA_SUGESTAO, 0)
    },
    qtdeTotalProdutoAdicionadoNoCarrinho () {
      if (!this.analisandoPorFilial) {
        return 0
      }

      const SOMA_SUGESTAO = (valorAtual, item) => {
        if (!item.no_carrinho) {
          return valorAtual;
        }

        return valorAtual + parseFloat(item.sugestao || 0)
      }

      return this.produtoPorFilial.reduce(SOMA_SUGESTAO, 0)
    }
  },
  watch: {
    modelValue () {
      if (this.modelValue) {
        this.atualizarCarrinho++
        this.buscarProdutosMultifiliaisTotais()
      } else {
        this.listaDeProduto = []
        this.produtosSelecionados = []
        this.produtoPorFilial = []
        if (this.analisandoPorFilial) this.linhaExpandida.expand(false)
        this.linhaExpandida = {}
      }
    },
    addComSucesso () {
      if (!this.addComSucesso) return

      this.produtoPorFilial.forEach(item => {
        if (this.produtosSelecionados.includes(item)) item.no_carrinho = true
      })

      this.produtosSelecionados = []
      this.atualizarCarrinho++
    },
    linhaExpandida (nova, antiga) {
      antiga.item && (this.linhaExpandidaAntiga = antiga)

      if (!this.historicoProdutosExpandidos.includes(nova) && nova.item) {
        this.historicoProdutosExpandidos.push(nova.item.idproduto)
      }
    },
    listaDeProdutosDinamico (itens) {
      if (itens.length === 0) {
        this.fecharDialog()
      }
    },
    analisandoPorFilial (novoValor) {
      this.produtosSelecionados = []

      // volta scroll para onde usuario estava antes de expandir por filial
      if (novoValor) {
        this.ultimoScrollTop = this.scrollDataTableRealTime.target.scrollTop
      } else {
        setTimeout(() => this.scrollDataTableRealTime.target.scrollTop = this.ultimoScrollTop, 500)
      }
    },
    embalagemMasterAtivada(){
      if (this.analisandoPorFilial){
        this.converterEmbalagemItensPorFilial();
      }
    }
  },
  mounted() {
    if (this.produtos.length > 0) {
      this.buscarProdutosMultifiliaisTotais()
    }
  },
  methods: {
    carrinhoDeCopraAlterado() {
      if (this.analisandoPorFilial) {
        this.buscarProdutoPorFilial(this.linhaExpandida.item);
      } else {
        this.buscarProdutosMultifiliaisTotais();
      }
    },
    converterEmbalagemItensPorFilial(){
      this.produtoPorFilial = this.converterEmbalagemItemsCompra(this.produtoPorFilial)
    },
    converteEmbalagemValor(item, campo) {
      if (item.tipo_fator_conversao === 'M') {
        return this.embalagemMasterAtivada ? (item[campo] * item.multiplo_compra) : item[campo];
      }

      return this.embalagemMasterAtivada ? (item[campo] / item.multiplo_compra) : item[campo];
    },
    indexMexAnterior (mes) {
      return (mes < 0 || mes > 11) ? 12 + mes : mes
    },
    verificaValoresInputValidos (item) {
      const precoCusto = parseFloat(item.preco_custo || 0)
      const sugestao = parseFloat(item.sugestao || 0)

      return item.filial != 9999 && (precoCusto <= 0 || sugestao <= 0)
    },
    verificaMultiplosProdutoValidos (produtos) {
      if (this.analisandoPorFilial) {
        this.addProdutoFilialNoCarrinho(produtos)
      } else {
        this.addProdutoNoCarrinhoPeloTotalizador(produtos)
      }
    },
    verificaProdutoParaAdicionarNoCarrinho (produto) {
      if (produto.filial == 9999 && this.analisandoPorFilial) {
        const filtraItens = item => !item.no_carrinho && item.filial != 9999;
        const produtosPorAdicionar = this.produtoPorFilial.filter(filtraItens)

        this.addProdutoFilialNoCarrinho(produtosPorAdicionar)
      } else if (produto.filial == 9999) {
        this.addProdutoNoCarrinhoPeloTotalizador([produto])
      } else {
        this.addProdutoFilialNoCarrinho([produto])
      }
    },
    addProdutoNoCarrinhoPeloTotalizador (produtos) {
      const produtosvalidos = produtos.filter(item => parseFloat(item.sugestao) > 0)

      if (produtosvalidos.length === 0) {
        this.dialogStatus.show = true;
        this.dialogStatus.txt = ["Não há sugestão de Compra para este produto."];
        return;
      }

      this.addProdutoFullNoCarrinho(produtos, this.completarCompra)
        .then(() => {
          this.produtosSelecionados = produtos
          this.removerProdutosSelecionados()
          this.atualizarCarrinho++
        })
        .catch(() => alert('Erro inesperado.'))
    },
    formatarValor (number = 0) {
      return this.Helpers.formatarValor(number)
    },
    formatarValorComCasas (number = 0, casas = this.QTDE_DECIMAIS) {
      return this.Helpers.formatarValorComCasas(number, casas)
    },
    activeRowSelected (row) {
      const itemFoiUltimoExpandido = (
        this.linhaExpandidaAntiga.item
        && row.idproduto === this.linhaExpandidaAntiga.item.idproduto
        && row.filial == 9999
      )

      const txtCinzaClaro = (
        this.historicoProdutosExpandidos.includes(row.idproduto)
        && !this.analisandoPorFilial
        && !itemFoiUltimoExpandido
      )

      return {
        'produto-no-carrinho': row.no_carrinho,
        'cursor-pointer': (row.filial == 9999),
        'bg-gray-300': (this.analisandoPorFilial && row.filial == 9999),
        'bg-ultima-row-expandida': (itemFoiUltimoExpandido && !this.analisandoPorFilial),
        'font-weight-bold': (this.analisandoPorFilial && row.filial == 9999),
        'text-gray-200': txtCinzaClaro
      }
    },
    expandirProdutoPorFilial (item, itemExpandido) {
      if (item.filial != 9999) {
        return 0
      } else if (!itemExpandido.isExpanded) {
        this.linhaExpandida = itemExpandido
        this.buscarProdutoPorFilial(item)
      } else {
        this.linhaExpandida = {}
        this.produtoPorFilial = []
      }

      itemExpandido.expand(!itemExpandido.isExpanded)
    },
    buscarProdutoPorFilial (item) {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        grupo: item.id_grupo,
        fornecedor: item.idfornecedor,
        id_produto: item.idproduto,
        completarCompra: this.completarCompra ? this.completarCompra : undefined
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getProdutoPorTodasFiliais(headers, params)
          .then((response) => {
            const { token, produtos } = response.data
            localStorage.setItem("token", token)

            produtos.map(item => {
              item.loteMinimoAuxiliar = item.lote_minimo
              return item
            })

            this.produtoPorFilial = produtos

            if (this.embalagemMasterAtivada){
              this.converterEmbalagemItensPorFilial();
            }
          })
          .catch(() => this.Helpers.logout())
      )
    },
    getNomeMes (indexMes) {
      if (!this.Helpers.nomeMeses[indexMes] || !(indexMes >= 0 && indexMes < 12) || this.mesAtual == null) {
        return 'Mês'
      }

      return this.Helpers.nomeMeses[indexMes].substring(0, 3)
    },
    fecharDialog () {
      this.$emit('update:modelValue', false)
    },
    removerProdutosSelecionados () {
      const itens = this.analisandoPorFilial ? this.produtoPorFilial : this.listaDeProduto

      const novosItens = itens.filter(item => !this.produtosSelecionados.includes(item))

      if (this.analisandoPorFilial) {
        this.produtoPorFilial = novosItens
      } else {
        this.listaDeProduto = novosItens
      }

      this.produtosSelecionados = []
    },
    addProdutoFilialNoCarrinho (items) {
      const itemsNaEmbalagemMinima = items.map(item => {
        const itemCopia = Object.assign({}, item);

        if (this.embalagemMasterAtivada) {
          // itemCopia.sugestao = itemCopia.sugestao * itemCopia.multiplo_compra
          itemCopia.preco_custo = itemCopia.preco_custo / itemCopia.multiplo_compra
        }

        return itemCopia
      })

      const PRODUTO_VALIDO = item => parseFloat(item.preco_custo) > 0 && parseFloat(item.sugestao) > 0;
      const produtosValidos = itemsNaEmbalagemMinima.filter(PRODUTO_VALIDO)

      const qtdeProdutosInvalidos = itemsNaEmbalagemMinima.length - produtosValidos.length

      if (qtdeProdutosInvalidos > 0) {
        this.dialogStatus.txt = []

        if (produtosValidos.length) {
          this.dialogStatus.txt.push(`- ${produtosValidos.length} produto${produtosValidos.length > 1 ? 's' : ''} adicionado no carrinho com sucesso.`)
        }

        if (qtdeProdutosInvalidos > 1) {
          this.dialogStatus.txt.push(` - ${qtdeProdutosInvalidos} produtos inválidos para serem adicionados no Carrinho, verifique o preço e a quantidade de produtos.`)
        } else {
          this.dialogStatus.txt.push("- 1 produto inválido para ser adicionado no Carrinho.")
        }

        this.dialogStatus.show = true
      }

      if (produtosValidos.length > 0) {
        this.produtosSelecionados = items.filter(PRODUTO_VALIDO)
        this.$emit('adicionar-produto-carrinho', produtosValidos)
      }
    },
    buscarProdutosMultifiliaisTotais () {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        grupo: this.grupoCompra,
        filial_compra: this.filialCompra,
        fornecedor: this.fornecedorCompra.id,
        completarCompra: this.completarCompra ? this.completarCompra : undefined,
        produtos: []
      };

      this.produtos.forEach(prod => {
        const {idproduto, idfornecedor, id_grupo: idgrupo} = prod
        params.produtos.push({idproduto, idfornecedor, idgrupo})
      })

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getListaProdutosAgrupados(headers, params)
          .then((response) => {
            const { token, produtos, ressuprimento, mesAtual } = response.data

            localStorage.setItem("token", token);
            this.listaDeProduto = produtos
            this.prazoFornecedor = ressuprimento.qtde_dias
            this.mesAtual = mesAtual
          })
          .catch(() => this.Helpers.logout())
      )
    },
    zerarSugestaoDeFiliais() {
      this.produtoPorFilial.map(item => {
        if (!item.no_carrinho) {
          item.sugestao = 0;
        }
      })
    }
  }
}
</script>

<style scoped>
.border-r {
  border-right: 1px solid rgba(0,0,0,.08);
}
.color-text {
  color: #444;
  font-weight: 600;
}
.rotate-90deg {
  transform: rotate(-90deg)
}
</style>


<style>
.border-right-table-multifiliais {
  border-right: 1px solid rgba(0,0,0,.08);
}
.bg-ultima-row-expandida {
  background: rgba(255,140,0,.3);
}
.produto-no-carrinho {
  background: rgba(5,140,0,.22);
}
#data-table-multifiliais-produtos .v-data-table__wrapper table tbody tr td  {
  font-size: 12px;
  padding: 1px 5px 1px 5px;
}
#data-table-multifiliais-produtos .v-data-table__wrapper table thead tr th  {
  font-size: 12px;
  padding: 0 4px 0 4px;
}
</style>
